import { FC, useCallback } from 'react';
import { Box } from '@chakra-ui/react';

import useSendDownloadSMS from 'common/hooks/useSendDownloadSMS';
import Button from 'components/_core/Button';
import Card from 'components/_core/Card';

import locales from './locales';
import { DownloadShineCardCardBottom as CardBottom } from './styles';
import { DownloadShineCardComponentProps } from './types';

const DownloadShineCardComponent: FC<DownloadShineCardComponentProps> = ({
  onSuccessfulSend,
  previewAppContent,
  topContent,
}) => {
  const { isSending, sendDownloadSMS } = useSendDownloadSMS(
    'Onboarding_App_Download',
  );
  const onDownloadPress = useCallback(async () => {
    await sendDownloadSMS();
    onSuccessfulSend();
  }, [onSuccessfulSend, sendDownloadSMS]);

  return (
    <Card
      borderColor={{
        base: 'transparent',
        md: 'inherit',
      }}
      padding="0"
    >
      {topContent === undefined ? null : topContent}

      {previewAppContent ? (
        <Box backgroundColor="grey.200" paddingX="space-16">
          {previewAppContent}
        </Box>
      ) : null}

      <CardBottom>
        <Button
          isLoading={isSending}
          justifyContent="center"
          marginTop="0"
          onClick={onDownloadPress}
        >
          {locales.download}
        </Button>
      </CardBottom>
    </Card>
  );
};

export default DownloadShineCardComponent;
